"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactModal = require("react-modal");
const moment = require("moment");
const AdFormBanner_1 = require("@dialogexe/cw-component-adform/AdFormBanner");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
class TicketModal extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClose = () => {
            this.props.onClose();
        };
    }
    render() {
        const { movieTitle, qrUrl, startTime, sal, seatsInfo } = this.props.ticket;
        const { isModalOpen, bannerId, bannerMobileId } = this.props;
        return (React.createElement(ReactModal, { isOpen: isModalOpen, ariaHideApp: false, className: "ticket_modal", overlayClassName: "ticket_modal-overlay", portalClassName: "ticket_modal-portal", shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, onRequestClose: this.handleClose },
            React.createElement("div", { className: "ticket-modal ticket-modal-header" },
                React.createElement("div", null,
                    " ",
                    movieTitle,
                    " "),
                React.createElement("div", { onClick: this.handleClose, className: "close-icon" },
                    React.createElement("img", { src: icons_1.closeBlackIcon, alt: "" }))),
            React.createElement("div", { className: "ticket-modal ticket-modal-body" },
                React.createElement("div", { className: "ticket-modal-body ticket-modal-body-date" },
                    React.createElement("div", { className: "time" },
                        React.createElement("div", null, moment(startTime).format("DD. MMMM YYYY")),
                        React.createElement("div", null, moment(startTime).format("hh:mm"))),
                    React.createElement("div", { className: "place" },
                        React.createElement("div", { className: "place place-title" }, " Sal "),
                        React.createElement("div", { className: "place place-sal" },
                            " ",
                            sal))),
                React.createElement("div", { className: "ticket-modal-body ticket-modal-body-qrurl" },
                    React.createElement("i", { className: "card-image", style: { backgroundImage: `url(${qrUrl})` } }))),
            seatsInfo.seats.map((seat, index) => (React.createElement("div", { key: index, className: "ticket-modal ticket-modal-seats" },
                React.createElement("div", { className: "seat-row" },
                    React.createElement("div", { className: "seat-row seat-row-title" }, " Rad "),
                    React.createElement("div", { className: "seat-row seat-row-value" },
                        " ",
                        seat.row,
                        " ")),
                React.createElement("div", { className: "seat-number" },
                    React.createElement("div", { className: "seat-number seat-number-title" }, " Seter "),
                    React.createElement("div", { className: "seat-number seat-number-value" }, seat.seats))))),
            React.createElement("div", { className: "ticket-modal ticket-modal-banner is-hidden-desktop" },
                React.createElement(AdFormBanner_1.default, { id: bannerId, mobileId: bannerMobileId }))));
    }
}
exports.TicketModal = TicketModal;
exports.default = TicketModal;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-my-page/TicketModal.tsx